import { useMemo } from "react";
import { connect } from "react-redux";
import store from "../@store";
const AuthComponent = ({ permissionList, children, authKey }) => {
  const isAuth = useMemo(() => {
    return permissionList.includes(authKey);
  }, [permissionList, authKey]);
  return isAuth ? children : null;
};
export const isAuth = (authKeys) => {
  let permissionList = store.getState().auth.permissionList;
  if (authKeys instanceof Array) {
    return authKeys.every(isAuth);
  }
  return permissionList.includes(authKeys);
};

export default connect((state) => ({
  permissionList: state.auth.permissionList,
}))(AuthComponent);
